import React from "react";
import {
    Container,
    SpaceBetween,
    Box,
    Badge,
    ExpandableSection,
    StatusIndicator,
    KeyValuePairs
} from "@amzn/awsui-components-react";
import { displayFalsyValue } from "../utils/DisplayHelpers";

const renderHopCard = (headerElement, renderableHop) => {
    const { renderedMetadata, metadata } = renderableHop;
    return (
        <Container>
            <SpaceBetween size="s">
                {headerElement(renderableHop)}
                <ExpandableSection
                    headerText="Expand Metadata"
                >
                    {renderedMetadata && renderedMetadata.length > 0 ? (
                        <KeyValuePairs
                            columns={2}
                            items={renderedMetadata.map(({ displayName, renderedValue }) => ({
                                label: displayName,
                                value: renderedValue
                            }))}
                        />
                    ) : metadata && (
                        <KeyValuePairs
                            columns={2}
                            items={Object.entries(metadata)
                                .map(([key, value]) => ({
                                    label: key,
                                    value: displayFalsyValue(value)
                                }))
                            }
                        />
                    )}
                </ExpandableSection>
            </SpaceBetween>
        </Container>
    );
};

const errorHopHeader = ({ name, position }) => (
    <Box>
        <SpaceBetween direction="horizontal" size="s">
            <Badge color="red">Position {position}</Badge>
            <Box variant="lg">
                <strong>{name}</strong>
            </Box>
            <StatusIndicator type="error">Error</StatusIndicator>
        </SpaceBetween>
    </Box>
);

const renderErrorHopCard = renderableHop => renderHopCard(errorHopHeader, renderableHop);

const deviceHopHeader = ({ position, metadata }) => (
    <Box>
        <SpaceBetween direction="horizontal" size="s">
            <Badge color="green">Position {position}</Badge>
            {metadata.deviceName && (
                <Box variant="lg">
                    <strong>Device:</strong> {metadata.deviceName}
                </Box>
            )}
            {metadata.interfaceName && (
                <Box variant="lg">
                    <strong>Interface:</strong> {metadata.interfaceName}
                </Box>
            )}
            <StatusIndicator type="success">Device</StatusIndicator>
        </SpaceBetween>
    </Box>
);

const renderDeviceHopCard = renderableHop => renderHopCard(deviceHopHeader, renderableHop);

const systemHopHeader = ({ name, position }) => (
    <Box>
        <SpaceBetween direction="horizontal" size="s">
            <Badge color="blue">Position {position}</Badge>
            <Box fontWeight="bold" fontSize="heading-s">{name}</Box>
            <StatusIndicator type="info">System</StatusIndicator>
        </SpaceBetween>
    </Box>
);

const renderSystemHopCard = renderableHop => renderHopCard(systemHopHeader, renderableHop);

const renderEmptyHop = renderableHop => (
    <Container>
        <SpaceBetween direction="vertical" size="l">
            <h2>{renderableHop.position}</h2>
            <h2>{renderableHop.name}</h2>
            <h3>Unsupported hop type</h3>
        </SpaceBetween>
    </Container>
);

export function HopCard({ renderableHop }) {
    if (!renderableHop) {
        return (
            <Container>
                <h2>There was an issue with this hop</h2>
            </Container>
        );
    }
    const { metadata } = renderableHop;

    switch (metadata.type) {
    case "DEVICE":
        return renderDeviceHopCard(renderableHop);
    case "SYSTEM":
        return renderSystemHopCard(renderableHop);
    case "ERROR":
        return renderErrorHopCard(renderableHop);
    default:
        return renderEmptyHop(renderableHop);
    }
}

export default HopCard;